import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/statistics/main',
    meta: { hiddenGroupSelector: true },
    components: {
      default: () => import('../views/statistics'),
      header,
      gnb,
    },
  },
  {
    path: '/views/statistics/main/:systemId',
    meta: { hiddenGroupSelector: true },
    components: {
      default: () => import('../views/statistics'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.KWShin.2025.06.23.
  {
    path: '/views/statistics/top-list',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/top-list'),
      header,
      gnb,
    },
  },
  {
    path: '/views/statistics/top-list/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/top-list'),
      header,
      gnb,
    },
  },
  {
    path: '/views/statistics/unused-list',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/unused-list'),
      header,
      gnb,
    },
  },
  {
    path: '/views/statistics/unused-list/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/unused-list'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2025.06.23.
  // BEGIN::Added.by.HJSeo.2026.06.19.
  {
    path: '/views/statistics/checklist',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/checklist'),
      header,
      gnb,
    },
  },
  {
    path: '/views/statistics/checklist/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/statistics/checklist'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.HJSeo.2026.06.19.
];
